


















































































































































import {Ax} from '@/utils';
import { Vue, Component } from 'vue-property-decorator'
import ReportList from "@/modules/budget/monitoring/reports-constructor/tabs/constructor/report-list.vue";
import FiltersForm from "@/modules/budget/monitoring/reports-constructor/tabs/constructor/filters-form2.vue";
import { Template } from '../../common/types/Template';
import { makeToast } from '../../common/utils/otherUtils';
import { cloneDeep, template } from 'lodash'
import { LoadToJournalRequest } from '../../common/types/roots/LoadToJournalRequest';
import { ReportName } from '../../common/types/roots/fields';
import { BatchExportRequest } from '../../common/types/roots/BatchExportRequest';
import ax from "@/utils/ax";
import { allReportNamesOptions } from '../../common/baseOptions';
import { Option } from "../../common/types/Option"
import i18nService from "@/services/i18n";

@Component({
    components: {
        'report-list': ReportList,
        'filters-form': FiltersForm
    }
})
export default class ReportsConstructor extends Vue {

    public journalParams: LoadToJournalRequest | null = null

    public batchExportParams: BatchExportRequest | null = null


    public selectedTemplate: Template | null = null 

    public availableReports: Record<string, Record<string, string>> | null = null;
    public isIncomesAvailable: boolean = false
    public isExpensesAvailable: boolean = false
    public userAccessLevels: Record<string, boolean> | null = null

    public tempI18Service: any = null

    private reportsToDownloadAsyncly: Set<ReportName> = new Set([
        'EIB',
        '1-27',
        '1-27-DAILY',
        '1-27-ACT',
        '2-43',
        'IRBO',
        'DVI',
        'DKI-P',
        'INCOME',
        'CASH-EXEC',
        'RS',
        'SVOD-PLAN',
        'SVOD-DOH',
        'RT',
        'RECON-STATEMENT',
        'BR',
        'income_kbk',
        'MBSP',
        'LOAN-STATUS',
        'RECON-PF-KF',
        'KSN',
        '4-20',
        'DKI-R',
        'SVOD-MB',
        'KF219-CO',
    ])

    public onSelectTemplate(template: Template | null) {
        this.selectedTemplate = template
    }

    setJournalParams(params: LoadToJournalRequest | null) {
        this.journalParams = params
    }

    setBatchExportParams(params: BatchExportRequest | null) {
        this.batchExportParams = params
    }

    async onExport(param?: '1-27-TC' | '1-27-AUDIT') {
        if (this.journalParams == null) {
            makeToast(this, this.tr('toasts.' + 'generate_report_first'), this.tr('toasts.' + 'message_title'), '')
            return
        }

        if (param === '1-27-TC' && (this.journalParams.reportName === '1-27' || this.journalParams.reportName === '1-27-DAILY')) {
            this.journalParams.excel_version = 'TC'
        } else if (param === '1-27-AUDIT' && (this.journalParams.reportName === '1-27' || this.journalParams.reportName === '1-27-DAILY')) {
            this.journalParams.excel_version = 'AUDIT'
        }
        
        await this.sendToJournalNew()
    }

    async onSpecificExport(param: '1-27-TC' | '1-27-AUDIT') {
        
    }

    async sendToJournalNew() {
        if (this.journalParams == null) {
            makeToast(this, this.tr('toasts.' + 'generate_report_first'), this.tr('toasts.' + 'message_title'), '')
            return
        }

        try {
            const requestBody = cloneDeep(this.journalParams)
            requestBody.name = this.getOptionLabel(allReportNamesOptions.find(o => o.value === this.journalParams?.reportName)!)
            if (requestBody.reportName === 'OWN-INCOME' && (requestBody as any).report_date) {
                requestBody.name += ` ${(requestBody as any).report_date}`
            }
            const endpoint = this.getEndpoint(requestBody.reportName)
            
            if (['4-20'].includes(this.journalParams.reportName)) { // Kotlin
                fetch(`/api/budget-execution-report-constructor/journal/${requestBody.reportName}`, {
                    method: 'POST',
                    body: JSON.stringify(requestBody),
                    headers: { 'Content-Type': 'application/json' }
                })
            } else { // Python
                fetch(`/api-py/monitoring/reports-constructor/journal/${endpoint}`, {
                    method: 'POST',
                    body: JSON.stringify(requestBody)
                })
            }

            makeToast(this, this.tr('toasts.' + 'export_started_journal'), this.tr('toasts.' + 'warning_title') + '!', 'info')

            setTimeout(() => this.$emit('update-journal'), 500)
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_save_journal'), this.tr('toasts.' + 'error'), 'danger')
        }
    }

    public async sendToJournal() {
        if (this.journalParams == null) {
            makeToast(this, this.tr('toasts.' + 'generate_report_first'), this.tr('toasts.' + 'message_title'), '')
            return
        }

        try {
            if (['4-20'].includes(this.journalParams.reportName)) { // Kotlin
                const requestBody = cloneDeep(this.journalParams)
                requestBody.name = this.getOptionLabel(allReportNamesOptions.find(o => o.value === this.journalParams?.reportName)!)
                const response = await fetch(`/api/budget-execution-report-constructor/journal/${requestBody.reportName}`, {
                    method: 'POST',
                    body: JSON.stringify(requestBody),
                    headers: { 'Content-Type': 'application/json' }
                })
                if (!response.ok) {
                    throw new Error('error')
                }
                makeToast(this, this.tr('toasts.' + 'export_started_journal'), this.tr('toasts.' + 'warning_title') + '!', 'info')
            } else { // Python
                const requestBody = cloneDeep(this.journalParams)
                requestBody.name = this.getOptionLabel(allReportNamesOptions.find(o => o.value === this.journalParams?.reportName)!)
                const endpoint = this.getEndpoint(requestBody.reportName)
                const response = await fetch(`/api-py/monitoring/reports-constructor/journal/${endpoint}`, {
                    method: 'POST',
                    body: JSON.stringify(requestBody)
                })
                if (!response.ok) {
                    throw new Error('error')
                }
                makeToast(this, this.tr('toasts.' + 'export_started_journal'), this.tr('toasts.' + 'warning_title') + '!', 'info')
            }

            makeToast(this, this.tr('toasts.' + 'saved_to_journal'), this.tr('toasts.' + 'message_title'), 'success')
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_save_journal'), this.tr('toasts.' + 'error'), 'danger')
        }

        this.$emit('update-journal')
    }

    public async  sendToJournalSvodPlan(report: number | string) {
        if (this.journalParams == null) {
            makeToast(this, this.tr('toasts.' + 'generate_report_first'), this.tr('toasts.' + 'message_title'), '')
            return
        }
        try {
            makeToast(this, this.tr('toasts.' + 'export_started_journal'), this.tr('toasts.' + 'warning_title') + '!', 'info')
            const requestBody: any = cloneDeep(this.journalParams)

            const endpoint = this.getEndpoint(requestBody.reportName)
            let guPart = '';
            if (requestBody.gu) {
                guPart = requestBody.gu.split(' - ')[0];
            }
            const yearPart = requestBody.report_date.split('-')[0];
            const region = requestBody.region;
            const abpList = requestBody.expenses.find(
                (item: any) => item.key === 'abp' && item.active
            );
            let abp: any = ' '
            if (abpList?.selected != null) {
                const selected = Array.isArray(abpList.selected)
                    ? abpList.selected
                    : [abpList.selected]; // если это не массив — обернём в массив
                if (selected.length > 0) {
                    abp = selected[0]
                }
            }
            const abpArr = requestBody.filter_settings.expenses.find(
                (item: any) => item.key === 'abp' && item.active
            );
            if (abpArr && abpArr.selected != null) {
                abpArr.selected = [].concat(abpArr.selected);
            }
            const templateDict = {
                '1': `Приложение 1_${guPart}_${yearPart}`,
                '2': `Приложение 2_${guPart}_${yearPart}`,
                '3': `Приложение 3_${guPart}_${yearPart}`,
                '4': `Приложение 4_${guPart}_${yearPart}`,
                '5': `Приложение 5_${guPart}_${yearPart}`,
                '6': `Приложение 6_${guPart}_${yearPart}`,
                '7': `Приложение 7_${abp}_${yearPart}`,
                '8': `Приложение 8_${abp}_${yearPart}`,
                '9': `Приложение 9_${abp}_${yearPart}`,
                '10': `Приложение 10_${abp}_${yearPart}`,
                '14': `Приложение 14_${region}_${yearPart}`,
                '15': `Приложение 15_${region}_${yearPart}`,
                '16': `Приложение 16_${region}_${yearPart}`,
                '17': `Приложение 17_${region}_${yearPart}`,
                '18': `Приложение 18_${region}_${yearPart}`,
                '19': `Приложение 19_${region}_${yearPart}`,
                'SPP': `СПП_${region}_${yearPart}`,
                'IPF_OBLIGATIONS': `ИПФ(Обязательства)_${abp}_${yearPart}`,
                'IPF_PAYMENTS': `ИПФ(Платежи)_${abp}_${yearPart}`,
                'SPF_PAYMENTS': `СПФ(Платежи)_${region}_${yearPart}`,
                'SPF_OBLIGATIONS': `СПФ(Обязательства)_${region}_${yearPart}`,
                'APPROVED': `Утвержденный план_${region}_${yearPart}`,
                '42': `Приложение 42_${region}_${yearPart}`
            }
            requestBody.report = String(report);
            requestBody.lang = this.$i18n.locale;
            if (requestBody.report in templateDict) {
                requestBody.name = templateDict[requestBody.report as keyof typeof templateDict];
            }
            const response = await fetch(`/api-py/monitoring/reports-constructor/journal/${endpoint}`, {
                method: 'POST',
                body: JSON.stringify(requestBody)
            })
            if (!response.ok) {
                throw new Error('error')
            }
            makeToast(this, this.tr('toasts.' + 'saved_to_journal'), this.tr('toasts.' + 'message_title'), 'success')
            // Ax(
            //     {
            //         url: `/api-py/monitoring/reports-constructor/journal/${endpoint}`,
            //         method: 'POST',
            //         responseType: 'blob',
            //         data: requestBody
            //     },
            //     (data) => {
            //         const url = window.URL.createObjectURL(new Blob([data as BlobPart]));
            //         const link = document.createElement('a');
            //         let title = 'Template';
            //         if (requestBody.report in templateDict) {
            //             title = templateDict[requestBody.report as keyof typeof templateDict];
            //         }
            //         link.href = url;
            //         link.setAttribute('download', `${title}.xlsx`);
            //         document.body.appendChild(link);
            //         link.click();
            //     },
            //     (error) => {
            //         console.log(error.toString())
            //     }
            // )
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_save_svod'), this.tr('toasts.' + 'error'), 'danger')
        }
        this.$emit('update-journal')
    }

    public async sendToJournalIncomeKBKSvod() {
        // fs  'mutuallyRedeeming', 'measureUnit', 'roundUpTo', '', 'regions', 'date', '', 'statuses', 'incomes', 'mutuallyRedeemingLevels'
        if (this.journalParams == null) {
            makeToast(this, this.tr('toasts.' + 'generate_report_first'), this.tr('toasts.' + 'message_title'), '')
            return
        }
        try {
            const fs = this.journalParams?.filter_settings

            if (fs?.reportName === 'income_kbk') {
                const req: any = {
                    region: fs?.regions[0]!,
                    repdate: fs?.date!,
                    measure_unit: fs?.measureUnit!,
                    round_up_to: fs?.roundUpTo!,
                    mutually_redeeming: fs?.mutuallyRedeeming!,
                    vzk_list: fs?.mutuallyRedeemingLevels?.map(v => parseInt(v.split('-')[1]))!,
                    status_list: fs?.statuses!,
                    filter_settings: fs,
                    name: '',
                    excel_name: this.journalParams.excel_name,
                    locale: this.$i18n.locale,
                    user_id: this.journalParams?.user_id
                }
                makeToast(this, this.tr('toasts.' + 'export_started_journal'), this.tr('toasts.' + 'warning_title') + '!', 'info')
                const response = await fetch('/api-py/monitoring/reports-constructor/journal/income_kbk_svod', {
                    method: 'POST',
                    body: JSON.stringify(req)
                })
                if (!response.ok) {
                    throw new Error('error')
                }
                makeToast(this, this.tr('toasts.' + 'saved_to_journal'), this.tr('toasts.' + 'message_title'), 'success')
            }
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_save_journal'), this.tr('toasts.' + 'error'), 'danger')
        }
        this.$emit('update-journal')
    }

    public async sendToJournalIncomeKBKSvodNew() {
        if (this.journalParams == null) {
            makeToast(this, this.tr('toasts.' + 'generate_report_first'), this.tr('toasts.' + 'message_title'), '')
            return
        }

        try {
            const fs = this.journalParams?.filter_settings
            if (fs?.reportName !== 'income_kbk') {
                return
            }

            const request: any = {
                region: fs?.regions[0]!,
                repdate: fs?.date!,
                measure_unit: fs?.measureUnit!,
                round_up_to: fs?.roundUpTo!,
                mutually_redeeming: fs?.mutuallyRedeeming!,
                vzk_list: fs?.mutuallyRedeemingLevels?.map(v => parseInt(v.split('-')[1]))!,
                status_list: fs?.statuses!,
                filter_settings: fs,
                name: '',
                locale: this.$i18n.locale,
                user_id: this.journalParams?.user_id
            }

            fetch(`/api-py/monitoring/reports-constructor/journal/income_kbk_svod`, {
                method: 'POST',
                body: JSON.stringify(request)
            })

            setTimeout(() => {
                makeToast(this, this.tr('toasts.' + 'export_started_journal'), this.tr('toasts.' + 'warning_title') + '!', 'info')
                this.$emit('update-journal')
            }, 500)
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_save_journal'), this.tr('toasts.' + 'error'), 'danger')
        }
    }

    public async batchExport() {
        if (!this.batchExportParams) {
            makeToast(this, this.tr('toasts.' + 'fill_required_fields'), this.tr('toasts.' + 'message_title'), '')
            return
        }

        try {
            const requestBody = cloneDeep(this.batchExportParams)
            const response = await fetch(`/api-py/monitoring/reports-constructor/batch-export/${this.batchExportParams.key}`, {
                method: 'POST',
                body: JSON.stringify(requestBody)
            })
            if (!response.ok) {
                throw new Error('error')
            }
            const responseData = await response.json()

            if ('is_date_valid' in responseData || 'already_in_progress' in responseData) {
                makeToast(this, this.tr('toasts.' + responseData.message), this.tr('toasts.' + 'message_title'), 'danger')
            } else {
                makeToast(this, this.tr('toasts.' + 'export_started_journal'), this.tr('toasts.' + 'warning_title') + '!', 'info')
            }
        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_save_journal'), this.tr('toasts.' + 'error'), 'danger')
        }

        this.$emit('update-journal')
    }

    private getEndpoint(reportName: ReportName): string {
        if (reportName === '1-27-ACT') {
            return 'act-1-27'
        }
        if (reportName === '1-27-DAILY') {
            return '1-27-daily'
        }
        if (reportName === 'CASH-EXEC') {
            if (this.journalParams?.filter_settings.classificationType === 'INCOMES') {
                return 'cash-ececution/2-19'
            } else {
                return 'cash-ececution/4-20'
            }
        }
        if (reportName === 'RECON-STATEMENT') {
            if (this.journalParams?.filter_settings.classificationType === 'INCOMES') {
                return 'recon-statement/1-27'
            } else {
                return 'recon-statement/4-20'
            }
        }
        if (reportName === 'SVOD-RAS') {
            return 'SVOD-RAS'
        }
        if (reportName === 'DKI-R') {
            return 'dki-r'
        }
        return reportName
    }

    public get showSendToJournalIncomeKBKSvod() {
        if (!this.journalParams) {
            return false
        }

        if (this.journalParams.reportName !== 'income_kbk') {
            return false
        }

        const regions = this.journalParams?.hasOwnProperty('regions') ? this.journalParams.regions : []

        if (!regions.length) {
            return false
        }

        return regions[0].slice(2) === '0000'

    }

    private async setAccessInfo() {
        try {
            const userAccessInfoResult = await fetch(`/api-py/monitoring/reports-constructor/user-access/get-user-access-info`,
            {
                method: 'POST',
                body: JSON.stringify({"user_id": this.$store.getters.user_uuid})
            })
            if (!userAccessInfoResult.ok) {
                throw new Error('error')
            }
            const userAccessInfo = await userAccessInfoResult.json();
            this.availableReports = userAccessInfo['available_reports']
            this.isIncomesAvailable = userAccessInfo['is_incomes_available']
            this.isExpensesAvailable = userAccessInfo['is_expenses_available']
            this.userAccessLevels = userAccessInfo['user_access_levels']


        } catch (error) {
            makeToast(this, this.tr('toasts.' + 'error_api_get_user_access_info'), this.tr('toasts.' + 'error'), 'danger')
        }
    }

    private async created() {
        this.tempI18Service = i18nService
        try {
            await this.setAccessInfo()

        } catch (error) {
            console.log(error)
        }
    }

    /** Метод-обертка для $t */
    public tr(key: any): string {
        if (typeof key !== 'string') {
            return ''
        }

        const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
        const text: string = String(this.$t(`${translationKey}.${key}`))

        return text
    }


    private getOptionLabel(option: Option<any>) : string {
        switch (this.tempI18Service.locale) {
            case 'kk':
                return option.labelKk || option.label || '';
            case 'en':
                return option.labelEn || option.label || '';
            case 'ru':
            default:
                return option.label || '';
        }
    }
}
